import { Attributes, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import { SARSDistributionType } from './SARSDistributionType.enum';

@NeoModel
export default class LegalEntityType extends ModelBase {
    static typeName = "LegalEntityType";

    public legalEntityTypeId: number = 0;

    @Rules.StringLength(30)
    @Rules.Required()
    @Attributes.Display("Legal Entity Type")
    public legalEntityTypeName: string = "";

    @Attributes.Display("Individual?")
    public isIndividual: boolean = false;

    @Attributes.Display("DWT Exempt?")
    public dwtExempt: boolean = false;

    @Rules.Required()
    @Attributes.Display("SARS ID Type")
    public sarsidTypeId: number | null = null;

    @Rules.StringLength(2)
    @Rules.Required()
    @Attributes.Display("SARS Distribution Type")
    public sarsDistributionType: SARSDistributionType = SARSDistributionType.BO;

    @Attributes.Display("Trust?")
    public isTrust: boolean = false;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.isIndividual && c.isTrust,"Legal entity cannot be both an individual and a trust.");
    }

    public toString(): string {
        if (this.isNew || !this.legalEntityTypeName) {
            return "New legal entity type";
        } else {
            return this.legalEntityTypeName;
        }
    }
}